import { axiosInstance } from '../../axios';
import {
  AdminMcpTool,
  AdminUser,
  CreatedUserAuthToken,
  RegeneratedAuthToken,
} from './user.interface';

export function fetchAdminUsers() {
  return axiosInstance
    .get<AdminUser[]>('/api/admin/user')
    .then((response) => response.data);
}

export function createAdminUser(email: string) {
  return axiosInstance
    .post<CreatedUserAuthToken>('/api/admin/user', { email })
    .then((response) => response.data);
}

export function fetchAdminUser(id: string) {
  return axiosInstance
    .get<AdminUser>(`/api/admin/user/${id}`)
    .then((response) => response.data);
}

export function fetchAdminUserMcpTools(id: string) {
  return axiosInstance
    .get<AdminMcpTool[]>(`/api/admin/user/${id}/mcp-tools`)
    .then((response) => response.data);
}

export function connectAdminUserTool(id: string, name: string) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/mcp-tools/connect`, { name })
    .then((response) => response.data);
}

export function disconnectAdminUserTool(id: string, name: string) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/mcp-tools/disconnect`, { name })
    .then((response) => response.data);
}

export function applyAdminUserToolPreset(id: string, presetId: string) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/mcp-tools/apply-preset`, {
      presetId,
    })
    .then((response) => response.data);
}

export function connectAdminUserContentfulTag(
  id: string,
  contentfulTagId: string,
) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/contentful-tags/connect`, {
      contentfulTagId,
    })
    .then((response) => response.data);
}

export function disconnectAdminUserContentfulTag(
  id: string,
  contentfulTagId: string,
) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/contentful-tags/disconnect`, {
      contentfulTagId,
    })
    .then((response) => response.data);
}

export function regenerateAdminUserToken(id: string) {
  return axiosInstance
    .post<RegeneratedAuthToken>(`/api/admin/user/${id}/regenerate-token`)
    .then((response) => response.data);
}

export function setAdminUserContentfulPat(id: string, token: string) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/user/${id}/contentful-pat`, { token })
    .then((response) => response.data);
}

export function deleteAdminUser(id: string) {
  return axiosInstance
    .delete<AdminUser>(`/api/admin/user/${id}`)
    .then((response) => response.data);
}
